import * as angular from "angular";
import { NationBuilderService } from "../../services/nation-builder.service";
import { DialogUtils } from "../../helper/dialog.helper";

let NationFormComponent = {
    selector: "vcNationForm",
    templateUrl:
        "/angular/components/nation-builder/nation-form.component.html",
    bindings: {
        nation: "=?",
    },
    controller: class NationFormController {
        // * bindings for typescript compiler *
        public nation?: any;
        // ************************************

        public addNationMessage = "";

        private readonly $cookies: any;
        private readonly $window: any;
        public readonly __env: any;

        private readonly dialog: DialogUtils;
        private readonly nationBuilderService: NationBuilderService;

        constructor(
            $cookies: any,
            $window: any,
            __env: any,
            DialogUtils: DialogUtils,
            NationBuilderService: NationBuilderService
        ) {
            this.$cookies = $cookies;
            this.$window = $window;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.nationBuilderService = NationBuilderService;
        }

        addNation(): void {
            this.addNationMessage = "";
            this.nationBuilderService
                .createNation(this.nation)
                .then((response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        this.$cookies.put("CURRENT_SLUG", this.nation.slug, {
                            domain: "." + this.__env.host,
                            path: "/",
                        });
                        if (json.hasOwnProperty("warning"))
                            this.$cookies.put("NB_WARNING", json.warning, {
                                domain: "." + this.__env.host,
                                path: "/",
                            });
                        this.dialog.hide(json);
                    } else {
                        this.addNationMessage = json.message;
                    }
                });
        }

        cancel(): void {
            this.dialog.cancel();
            this.$window.history.back();
        }
    },
};

angular
    .module("nationBuilder")
    .component(NationFormComponent.selector, NationFormComponent);
